const LoadingCard = () => {
    return (
        <div className="product-card store-card-skeleton" aria-hidden="true">
            <div className="product-card-inner product-card-inner--store my-2 d-flex flex-column h-100">
                <div className="product-image">
                    <div className="image-wrapper w-100 store-card-skeleton__media store-card-skeleton__fill" />
                </div>
                <div className="product-description flex-grow-1 d-flex flex-column">
                    <div
                        className="store-card-skeleton__line store-card-skeleton__fill rounded-pill mb-2"
                        style={{ width: '38%', height: '0.5rem' }}
                    />
                    <div
                        className="store-card-skeleton__line store-card-skeleton__fill rounded-1 mb-2"
                        style={{ width: '94%', height: '0.85rem' }}
                    />
                    <div
                        className="store-card-skeleton__line store-card-skeleton__fill rounded-1 mb-3"
                        style={{ width: '62%', height: '0.85rem' }}
                    />
                    <div className="d-flex align-items-center gap-1 mb-3">
                        {[0, 1, 2, 3, 4].map((i) => (
                            <span
                                key={i}
                                className="store-card-skeleton__star store-card-skeleton__fill rounded-1"
                            />
                        ))}
                        <span
                            className="store-card-skeleton__line store-card-skeleton__fill rounded-1 ms-1"
                            style={{ width: '2rem', height: '0.65rem' }}
                        />
                    </div>
                    <div className="mt-auto pt-2">
                        <div
                            className="store-card-skeleton__line store-card-skeleton__fill rounded-1 mb-2"
                            style={{ width: '28%', height: '0.55rem', opacity: 0.7 }}
                        />
                        <div
                            className="store-card-skeleton__line store-card-skeleton__fill rounded-1"
                            style={{ width: '42%', height: '1.2rem' }}
                        />
                    </div>
                    <div className="d-flex justify-content-end gap-2 pt-3 mt-2 border-top border-light">
                        <span className="store-card-skeleton__btn store-card-skeleton__fill rounded-3" />
                        <span className="store-card-skeleton__btn store-card-skeleton__fill rounded-3" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoadingCard;
